import { ProductAccessoryType } from 'b2b-apps/core/product/redux/productAccessories/types';
import { ProductFullType } from 'b2b-apps/core/product/redux/products/full/types';
import { ProductTileType } from 'b2b-apps/core/product/redux/products/tile/types';
import {
  OSS_INTERACTION, OSS_INTERACTION_LABEL,
  OSS_INTERACTION_PARAMETERS,
  SearchAnalyticsData,
  SearchAnalyticsOssData,
  SearchData,
  SearchOssData,
} from 'b2b-apps/shop/analytics/redux';
import {
  AnalyticsProductType,
  TEALIUM_PROD_ACTION,
  TEALIUM_PROD_LIST,
  ZERO,
} from 'b2b-apps/shop/analytics/types/types';
import { preparePrice, prepareQuantity, prepareStock } from 'b2b-apps/shop/analytics/utils/analytics';
import { CatalogSearchType } from 'b2b-apps/shop/catalog/redux/search/types';

const getResultsPerPageFromSearchData = (data: CatalogSearchType): number => (
  data.site?.listView
    .allowedProductsPerPage
    .find(config => config.current)
    ?.numberOfProducts || 48
);

//TODO: move this utils into main analytics utils and use in other places
const getProductsAnalytics = (
  products: (ProductFullType | ProductTileType | ProductAccessoryType)[],
  { action, list, quantity }: {
    action: TEALIUM_PROD_ACTION,
    list: TEALIUM_PROD_LIST,
    quantity: number,
  },
): AnalyticsProductType[] => (
  products.map((product, index) => {
    const { analytics, sku, effectivePricing, settings } = product;

    return {
      action,
      categories: analytics.categories,
      id: sku,
      pos: `${index + 1}`,
      price: preparePrice(effectivePricing.mainPrice),
      quan: prepareQuantity(quantity),
      stock: prepareStock(settings.quantity),
      list,
    };
  })
);

const getSearchAnalyticsOssData = ({
  interaction,
  interactionLabel,
  query,
  originalQuery,
  sortType,
  resultsPerPage,
  page,
  productsCount,
  listType,
}: SearchOssData & {
  interaction: OSS_INTERACTION,
  interactionLabel: OSS_INTERACTION_LABEL
}): SearchAnalyticsOssData => ({
  interaction,
  interactionLabel,
  type: TEALIUM_PROD_LIST.search,
  term: query.toLowerCase(),
  ...(originalQuery && { originalQuery: originalQuery.toLowerCase?.() }),
  ...(sortType && { sortType }),
  ...(resultsPerPage != null && { resultsPerPage: `${resultsPerPage}` }),
  ...(page != null && { pageIndex: `${page}` }),
  ...(productsCount != null && { resultsCount: productsCount ? `${productsCount}` : ZERO }),
  ...(listType && { listType }),
});

const getSearchAnalyticsData = ({
  id,
  query,
  originalQuery,
  pageType,
  resultsPerPage,
  page,
  productsCount,
  listType,
  sortType,
  products,
  productsAction,
  productsList,
  productQuantity,
}: SearchData): SearchAnalyticsData => {
  const {
    interaction,
    interactionLabel,
  } = OSS_INTERACTION_PARAMETERS[id];

  return {
    interaction: id,
    ...(pageType && {
      page: { type: pageType },
    }),
    ...(products?.length && {
      prod: getProductsAnalytics(
        products,
        {
          action: productsAction,
          list: productsList,
          quantity: productQuantity,
        },
      ),
    }),
    oss: getSearchAnalyticsOssData({
      interaction,
      interactionLabel,
      query,
      originalQuery,
      sortType,
      resultsPerPage,
      page,
      productsCount,
      listType,
    }),
  };
};

export {
  getResultsPerPageFromSearchData,
  getSearchAnalyticsData,
  getSearchAnalyticsOssData,
};
